import LoadingIndicator from 'Shared/loading_indicator';

interface LoadingIndicatorOptions {
   pendingMessage: string;
   successMessage?: string;
   failureMessage: string;
}

/**
 * Wraps a promise with the loading indicator to show pending, success, and failure states
 */
export const withLoadingIndicator = <T>(
   promise: Promise<T>,
   options: LoadingIndicatorOptions
): Promise<T> =>
   new Promise((resolve, reject) => {
      LoadingIndicator.withPromise(promise, {
         pendingMessage: options.pendingMessage,
         successMessage: options.successMessage,
         failureMessage: options.failureMessage,
         hideSuccessMessage: !options.successMessage, // Hide if no success message provided
      });

      // Pass through the original promise's result
      promise.then(resolve).catch(reject);
   });
